export const environment = {
  production: true,
  hostname: 'dr.osparts.toyota.com',
  REDIRECT_URL: 'https://dr.osparts.toyota.com/',

  CLIENT_ID: 'cfbff0df-3131-4017-a0e6-bb94de0626f5',
  TENANT_ID:
    'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb',

  ccsApiUrl: 'https://alb.ccsdev.toyota.com/os-parts/',
  ccsApiBasicAuth: 'Basic ' + btoa('CCS:78fa095d-3f4c-48b1-ad50-e24c31d5cf35'),

  fluctuationAllowanceKey: 'rkgjaidMdU9pnQMRedt618ARBr9XZto39SdaFf7C',
  fluctuationAllowanceUrl:
    'https://as1t6zet1k.execute-api.us-west-2.amazonaws.com/dr/api/v1/fluctuationallowance',

  bulkAdjustmentKey: 'O37RfAJ5TQuwf5W8fMtP6x4Y5FBQZA09IUQYOSz7',
  bulkAdjustmentUrl:
    'https://x723v0fngc.execute-api.us-west-2.amazonaws.com/dr/api/v1/bulkadjustment',

  rundownKey: 'KfA7zWaRq8aU6qsTF3N8J897NCy6X4mN3HHDNSKa',
  rundownUrl:
    'https://w5gfe0pd66.execute-api.us-west-2.amazonaws.com/dr/api/v1/rundown',

  orderForecastKey: 'LBuBY5FQka3Oqkqy1TJqM567zeibjzBB6B3gksvY',
  orderForecastUrl:
    'https://cy1frhob26.execute-api.us-west-2.amazonaws.com/dr/api/v1/orderforecast',

  lookupKey: 'KpasK9Dok719zb7O9telc3Vt1oOpd2Zu18EB4wEC',
  lookupUrl:
    'https://mwqxr4xng9.execute-api.us-west-2.amazonaws.com/dr/api/v1/lookup',

  getsudoKey: 'N4qyDk5KUFBjj4AOhet76wC76XYw3LX2OXR2QgC4',
  getsudoUrl:
    'https://2p4bb85l21.execute-api.us-west-2.amazonaws.com/dr/api/v1/getsudo',

  // This is in Setup service lambda with different url
  getsudoDatesUrl:
    'https://61bmsdk4g6.execute-api.us-west-2.amazonaws.com/dr/api/v1/getsudo',

  setupKey: 'or901ISMHHt7c8crHlDC1OibpcrBRPZ43MvNwt73',
  setupUrl:
    'https://61bmsdk4g6.execute-api.us-west-2.amazonaws.com/dr/api/v1/setup',

  adjustmentEnquiryKey: 'YtboM0sYTD48812LG5AMQ4hbWNUipNpL5BSHBnKK',
  adjustmentEnquiryUrl:
    'https://oixrqdhn1b.execute-api.us-west-2.amazonaws.com/dr/api/v1/adjustment',


  //ospipe roles

  partMaintenance:'https://pp45141stj.execute-api.us-west-2.amazonaws.com/dr/api/v1/partMaintenance',
  partMaintenanceKey:'cFpyzRVEB79RlMc9CyGzx4euDMkrD2tb5S2Ca68l',

  partStatusUrl:'https://yx7kwf4kkb.execute-api.us-west-2.amazonaws.com/dr/api/v1/getpartstatus',
  partStatusKey:'ilqByBmKgo2X25lV21yH595cWQeW0Nk7akelq8vT',

  ospLookupUrl:'https://296hr1723i.execute-api.us-west-2.amazonaws.com/dr/api/v1/lookup',
  ospLookupKey:'KpasK9Dok719zb7O9telc3Vt1oOpd2Zu18EB4wEC',

  ospSealVerificationUrl:'https://e33aq4e88c.execute-api.us-west-2.amazonaws.com/dr/api/v1/sealVerification',
  ospSealVerificationKey:'0Zq65rZWeP6y5TA4GZdpe7VRjpgo8HBd4IgQHeJH',

      //PIE lambda urls

  sendToPieData: `https://api-int.pie.toyota.com/tnso/update-container-info`,

  airOrderUrl: 'https://llgwajaq28.execute-api.us-west-2.amazonaws.com/dr/api/v1/airfreight',
  airOrderKey: 'l2fKvvYkHja4DgYkwfc2eHzEEcBup5M7T9JoyA0j',



  // dr llp

  stockingPaceKey:'hgXYulrLE99VFl0FWxhpslNBpC5yptm5m6Q7JQZ6',
  moduleStockingPaceUrl: 'https://fimf8pjvfg.execute-api.us-west-2.amazonaws.com/dr/api/v1/stockingPace',


  moduleStockingKey: 'g3lcvPMlLg53iwkURQkMb5SFWBhkKm3kaee6fIY9',
  moduleStockingUrl: 'https://myc6v790q4.execute-api.us-west-2.amazonaws.com/dr/api/v1/modulestocking',


  prodProgressKey: 'dp8c5bfsuM4MpQ3HDTSj6kIY7gV2vGW76PVSvRJ0',
  prodProgressUrl: 'https://g6b30j2gtc.execute-api.us-west-2.amazonaws.com/dr/api/v1/prodprogress',



    uvrKey:'fG6yItugIS68GZF66xQm68uxTpsvAA042OA3n98I',
    uvrUrl:'https://z5di6knkvc.execute-api.us-west-2.amazonaws.com/dr/api/v1/invuvr',


    partsinventoryKey: 'od5dA2om7H7Elu9xXny603zlJZRnHanI3QaRhFDR',
    partsinventoryUrl: 'https://kbthmqk8x6.execute-api.us-west-2.amazonaws.com/dr/api/v1/partsinventory',

  procurementUrl: 'https://g6b30j2gtc.execute-api.us-west-2.amazonaws.com/dr/api/v1/procurement',
  devanningHistoryURL:'https://fimf8pjvfg.execute-api.us-west-2.amazonaws.com/dr/api/v1/inventory'


};
